import React from 'react';
import Profile from 'components/app/profile/Profile';

/**
 * ProfilePage — route-level page for the current user's profile
 * (mounted at `user/profile`). Thin wrapper around the Profile feature
 * component so routing stays decoupled from the feature implementation.
 */
const ProfilePage = () => (
  <div className="tw-px-4 tw-py-5 sm:tw-px-6">
    <Profile />
  </div>
);

export default ProfilePage;
